var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
/**
 * Container for match vs part. Includes both club names and emblems (if given) and the middle part (time, score or vs)
 * @constructor
 * @param props MatchVsContainerProps
 */
export var MatchVsContainer = function (props) {
    var homeLogoFileName = props.homeLogoFileName, homeTeamName = props.homeTeamName, awayLogoFileName = props.awayLogoFileName, awayTeamName = props.awayTeamName, scale = props.scale, score = props.score, afterMatchPenaltyScore = props.afterMatchPenaltyScore, date = props.date;
    return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "center", alignItems: "stretch", sx: {
            height: "96px",
            "& > :nth-of-type(1) > :nth-of-type(1)": {
                alignItems: homeLogoFileName ? "center" : "flex-end",
                pr: homeLogoFileName ? "unset" : 2
            },
            "& > nth-last-of-type(1) > nth-last-of-type(1)": {
                alignItems: awayLogoFileName ? "center" : "flex-start",
                pl: homeLogoFileName ? "unset" : 2
            }
        } }, { children: [_jsx(ClubNameAndLogo, { logoFileName: homeLogoFileName, teamName: homeTeamName, scale: scale !== null && scale !== void 0 ? scale : 1 }), _jsx(ScoreTimeOrVsElement, { score: score, afterMatchPenaltyScore: afterMatchPenaltyScore, date: date }), _jsx(ClubNameAndLogo, { teamName: awayTeamName, logoFileName: awayLogoFileName, scale: scale !== null && scale !== void 0 ? scale : 1 })] })));
};
function ClubNameAndLogo(props) {
    var teamName = props.teamName, logoFileName = props.logoFileName, scale = props.scale;
    return (_jsx(Grid, __assign({ item: true, xs: true }, { children: _jsxs(Stack, __assign({ justifyContent: logoFileName ? "space-between" : "center", textAlign: "center", sx: { height: "100%" } }, { children: [logoFileName &&
                    _jsx("img", { src: logoFileName, alt: teamName, style: {
                            maxWidth: "80px",
                            maxHeight: "80px",
                            transform: "scale(".concat(scale, ")"),
                            transition: "transform 1.5s",
                        } }), _jsx(Typography, __assign({ variant: "bodyMBold" }, { children: teamName }))] })) })));
}
export function ScoreTimeOrVsElement(props) {
    var score = props.score, afterMatchPenaltyScore = props.afterMatchPenaltyScore, date = props.date;
    var theme = useTheme();
    var isIos = useIosContext().isIos;
    var getComponent = function () {
        var _a, _b;
        if (afterMatchPenaltyScore && score) {
            return (_jsxs(Box, __assign({ sx: {
                    backgroundColor: "primary.main",
                    height: "51px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 1,
                    pt: "4px",
                    whiteSpace: "nowrap",
                    minWidth: "40px",
                } }, { children: [_jsx(Typography, __assign({ variant: "bodyL", color: theme.palette.background.paper, sx: {
                            lineHeight: "25px",
                        } }, { children: score })), _jsx(Typography, __assign({ variant: "bodyL", color: theme.palette.secondary.main, sx: {
                            lineHeight: "25px",
                        } }, { children: afterMatchPenaltyScore }))] })));
        }
        else if (score) {
            return (_jsx(Box, __assign({ sx: {
                    backgroundColor: "primary.main",
                    height: "51px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 1,
                    pt: "4px",
                    whiteSpace: "nowrap",
                    minWidth: "40px",
                } }, { children: _jsx(Typography, __assign({ variant: "h4", color: theme.palette.background.paper, sx: (_a = {},
                        _a[theme.breakpoints.down("sm")] = isIos && {
                            '@media (-webkit-min-device-pixel-ratio: 2)': {
                                fontWeight: 500, // Adjust font weight for iPhones
                            },
                        },
                        _a) }, { children: score })) })));
        }
        if (date) {
            return (_jsx(Typography, __assign({ variant: "h4", sx: (_b = {
                        color: theme.palette.primary.main
                    },
                    _b[theme.breakpoints.down("sm")] = isIos && {
                        '@media (-webkit-min-device-pixel-ratio: 2)': {
                            fontWeight: 500, // Adjust font weight for iPhones
                        },
                    },
                    _b) }, { children: date.getHours() === 0
                    ? "vs"
                    : date.toLocaleTimeString(["sl-sl"], {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: false,
                    }) })));
        }
        return (_jsx(Typography, __assign({ variant: "bodyL" }, { children: "VS" })));
    };
    return (_jsx(Stack, __assign({ sx: { width: "60px", height: "100%" }, direction: "column", justifyContent: "center", alignItems: "center" }, { children: getComponent() })));
}
